import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  poster: string;
  year: number;
  rating: number;
  quality: string;
  category: string;
  genres: string[];
}

const categoryLabels: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  anime: '动漫',
  variety: '综艺',
};

export default function MovieCard({ id, title, poster, year, rating, quality, category, genres }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={poster}
          alt={`${title} - 蘑菇影视高清在线观看`}
          title={`${title} ${categoryLabels[category] || ''} 高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-foreground-50 rounded whitespace-nowrap">
            {quality}
          </span>
        </div>

        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/80 backdrop-blur-sm px-1.5 py-0.5 rounded text-xs">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          </div>
          <span className="text-accent-400 font-medium">{rating}</span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
          <div className="flex flex-wrap gap-1">
            {genres.slice(0, 3).map((genre) => (
              <span
                key={genre}
                className="px-1.5 py-0.5 text-[10px] bg-background-200/80 backdrop-blur-sm text-foreground-200 rounded whitespace-nowrap"
              >
                {genre}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">
          {year} · {categoryLabels[category] || category}
        </p>
      </div>
    </Link>
  );
}